import { selectIsOauthAuthenticatable } from 'ducks/currentUser/selectors'
import { doUpdateCurrentUserForOnboarding } from 'ducks/currentUser/operations'
import { doBootstrapOnboarding } from '../../actions'
import { doUpdateCompanyProfile } from '../../ducks/companyProfile'
import { V3_VERIFICATION_PAGE } from '../../pages'
import { doFinishOnboarding } from '../actions'

export function doSaveAndRedirect(fields) {
  return (dispatch, getState) => {
    const state = getState()
    const isLastStep = selectIsOauthAuthenticatable(state)

    const companyFields = {
      name: fields.companyName,
      numberOfEmployees: fields.numberOfEmployees,
      industry: fields.industry,
    }

    const userFields = {
      companyRole: fields.companyRole,
    }

    return Promise.all([
      dispatch(doUpdateCompanyProfile(companyFields)),
      dispatch(doUpdateCurrentUserForOnboarding(userFields)),
    ]).then(() => {
      // HACK (jscheel): Because updating the company profile can change the
      // subdomain, we need to get the new subdomain back. This really should
      // come from the backend response, but in the interest of time, just doing
      // an extra request here to get this out.
      return dispatch(doBootstrapOnboarding()).then(() => {
        if (isLastStep) {
          return dispatch(doFinishOnboarding())
        }
        return dispatch({
          type: V3_VERIFICATION_PAGE,
        })
      })
    })
  }
}
